export enum ReliabilityRogueReasonType {
  NoDefectSixMonths = 1,
  Scrap = 2,
  Exchange = 3,
  Other = 4,
}

export const ReliabilityRogueRejectReasonType = [
  { key: "NO DEFECT DURING SIX MONTHS", value: ReliabilityRogueReasonType.NoDefectSixMonths },
  { key: "OTHER", value: ReliabilityRogueReasonType.Other },
];

export const ReliabilityRogueConfirmedReasonType = [
  { key: "EXCHANGE", value: ReliabilityRogueReasonType.Exchange },
  { key: "SCRAP", value: ReliabilityRogueReasonType.Scrap },
  { key: "OTHER", value: ReliabilityRogueReasonType.Other },
];

export const ReliabilityRogueReasonChoices = [
  ...ReliabilityRogueRejectReasonType,
  ...ReliabilityRogueConfirmedReasonType,
];
